import styled from 'styled-components'

export const NotificationItem = styled.div`
  position: relative;
  display: flex;
  gap: var(--spacer-4);
  max-width: 100%;

  &.isUnread {
    &::after {
      content: '';
      background-color: var(--red);
      height: 0.5rem;
      width: 0.5rem;
      position: absolute;
      top: 0;
      right: -0.5rem;
      border-radius: 50%;
    }
  }
`

NotificationItem.displayName = 'NotificationItem'

export const NotificationContent = styled.div`
  display: grid;
  gap: var(--spacer-1);
`

NotificationContent.displayName = 'NotificationContent'
